import { LocalStorageRepository } from '../infra/adapters/localStorageRepository';
import { SessionStorageRepository } from '../infra/adapters/sessionStorageRepository';
import { CookieStorageRepository } from '../infra/adapters/cookieStorageRepository';
import { StorageService } from '../application/services/StorageService';

export function storageBuild() {
  const localStorageRepo = new LocalStorageRepository();
  const sessionStorageRepo = new SessionStorageRepository();
  const cookieStorageRepo = new CookieStorageRepository();

  const repo = {
    localSaveData: localStorageRepo.saveData,
    localGetData: localStorageRepo.getData,
    sessionSaveData: sessionStorageRepo.saveData,
    sessionGetData: sessionStorageRepo.getData,
    cookieSaveData: cookieStorageRepo.saveData,
    cookieGetData: cookieStorageRepo.getData,
  };


  const service = new StorageService(repo);

  return { repo, service };
}

